import { ExternalLink } from "lucide-react";
import { useStore } from "@/store/useStore";

const LINKS = {
  airpods: {
    label: "Apple AirPods Pro 3",
    href: "https://time.com/collections/best-inventions-2025/7318483/apple-airpods-pro-3/",
  },
  melasyl: {
    label: "L'Oréal Groupe Melasyl",
    href: "https://time.com/collections/best-inventions-2025/7318255/loreal-groupe-melasyl/",
  },
  lotus: {
    label: "Lotus Ring",
    href: "https://time.com/collections/best-inventions-2025/7318226/lotus-ring/",
  },
};

export default function AttributionBar() {
  const product = useStore((s) => s.product);
  const item = LINKS[product];

  return (
    <div
      data-testid="time-attribution-bar"
      className="pointer-events-none fixed inset-x-0 top-[62px] z-30 flex justify-center px-4 sm:top-[80px] lg:top-[72px]"
    >
      <a
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="time-attribution-link"
        className="pointer-events-auto group flex items-center gap-2 rounded-full border border-[#E60000]/60 bg-[#05070d]/80 px-3 py-1.5 backdrop-blur-md transition-all hover:border-[#00f0ff]/70 hover:shadow-[0_0_18px_rgba(0,240,255,0.3)]"
      >
        <span className="mono rounded-sm border border-[#E60000] px-1.5 py-0.5 text-[0.68rem] font-semibold uppercase tracking-wider text-[#ff4d4d]">
          TIME
        </span>
        <span className="text-[0.68rem] font-medium tracking-wide cyan-text sm:text-xs">
          Best Inventions 2025 · <span className="text-slate-200 group-hover:text-white">{item.label}</span>
        </span>
        <ExternalLink className="h-3 w-3 text-[#7fe9ff]" />
      </a>
    </div>
  );
}
